/**
 * Central registry of feature toggle names used across the system.
 * These values map 1:1 to FeatureFlagRecord.name in the database.
 */
export var FeatureToogles;
(function (FeatureToogles) {
    FeatureToogles["UrlCapture"] = "urlCapture";
    FeatureToogles["GDriveIntegration"] = "GDriveIntegration";
    FeatureToogles["AiFileValidationAttachFileData"] = "ai_file_validation_attach_file_data";
    FeatureToogles["Integrations"] = "integrations";
    FeatureToogles["DevDocs"] = "devDocs";
    FeatureToogles["ApiTokens"] = "apiTokens";
})(FeatureToogles || (FeatureToogles = {}));
